import React, { useCallback } from 'react'
import style from "./index.module.scss"
import Model from 'components/model'
import Title from 'components/title'
import Input from 'components/input'
import { useInput } from 'hooks/useInput'
import Button from 'components/button'
import useGeneralReducer from 'hooks/useGeneralReducer'
import { createAction } from 'store/ActionTypes'
import { $changePasswd, clearLoginInfo } from 'service/sign'
import { OK, RouterPaths } from 'utils/constant'
import { filter } from 'utils/filter'
import Card from 'components/card/Card'
import { useHistory } from 'react-router-dom'
import { isMobile } from 'utils/utils'

interface StateType {
  loading: boolean
  step: number
  curPasswdHint?: string
  newPasswdHint?: string
  newPasswdHint2?: string
}

const initState: StateType = {
  loading: false,
  step: 1
}

interface Props {
  show: boolean
  onHide: () => any
}

function ModifyPasswd ({ show, onHide }: Props) {
  const [curPasswd, setCurPasswd] = useInput('')
  const [newPasswd, setNewPasswd] = useInput('')
  const [newPasswd2, setNewPasswd2] = useInput('')
  const [state, dispatch] = useGeneralReducer(initState)

  const history = useHistory()

  function validate() {
    if (curPasswd && newPasswd && newPasswd2 && newPasswd === newPasswd2) {
      return true
    }
    let key = ''
    let hint = ''
    if (!curPasswd) {
      key = 'curPasswdHint'
      hint = '请输入当前密码'
    } else if (!newPasswd) {
      key = 'newPasswdHint'
      hint = '请输入新密码'
    } else if (!newPasswd2) {
      key = 'newPasswdHint2'
      hint = '请再次输入新密码'
    } else if (newPasswd !== newPasswd2) {
      key = 'newPasswdHint2'
      hint = '两次密码输入不一致'
    }
    dispatch(createAction(key, hint))
    return false
  }

  function initHint() {
    dispatch(createAction('curPasswdHint', ''))
    dispatch(createAction('newPasswdHint', ''))
    dispatch(createAction('newPasswdHint2', ''))
  }



  async function onSubmit() {
    if (state.step === 2) {
      // initInput()
      // return onHide()
      clearLoginInfo()
      isMobile() ? history.push(RouterPaths['signin-phone']) : history.push(RouterPaths['signin-qr'])
      return
    }
    if (validate()) {
      dispatch(createAction('loading', true))
      try {
        const data = await $changePasswd(curPasswd, newPasswd, newPasswd2)
        if (data.status === OK) {
          dispatch(createAction('step', 2))
          initHint()
        } else {
          const error = filter(data.code, data.error)
          dispatch(createAction('curPasswdHint', error))
        }
      } catch (e) {
        dispatch(createAction('curPasswdHint', '网络错误'))
      } finally {
        dispatch(createAction('loading', false))
      }
    }
  }

  const handleHide = useCallback(() => {
    if (state.step === 2) {
      clearLoginInfo()
      isMobile() ? history.push(RouterPaths['signin-phone']) : history.push(RouterPaths['signin-qr'])
      return
    } else {
      onHide()
    }
  }, [history, onHide, state.step])

  document.onkeydown = function (e) {
    if (e.key === 'Enter') {
      onSubmit()
    }
  }
  
  //  else {
  //   document.onkeydown = function (e) {
  //     if (e.key === 'Enter') {
  //       setshowModal({ modal: false, text: '' })
  //     }
  //   }
  // }
  return (
    <Model
      show={show}
      onHide={handleHide}
    >
      <div className={style['modify-passwd']}>
        <Title
          clickLeft={() => dispatch(createAction('step', 1))}
          title="修改密码"
        />
        {
          state.step === 1
            ? (
        <>
          <label className={style.label}>
            <div className={style.text}>当前密码：</div>
            <Input 
              value={curPasswd}
              onChange={setCurPasswd}
              onFocus={() => dispatch(createAction('curPasswdHint', ''))}
              placeholder="请输入当前密码"
              hint={state.curPasswdHint}
              type="password"
            />
          </label>
          <label className={style.label}>
            <div className={style.text}>新密码：</div>
            <Input 
              value={newPasswd}
              onChange={setNewPasswd}
              onFocus={() => dispatch(createAction('newPasswdHint', ''))}
              placeholder="请输入新密码"
              hint={state.newPasswdHint}
              type="password"
            />
          </label>
          <label className={style.label}>
            <div className={style.text}>确认密码：</div>
            <Input 
              value={newPasswd2}
              onChange={setNewPasswd2}
              onFocus={() => dispatch(createAction('newPasswdHint2', ''))}
              placeholder="请重复输入新密码"
              hint={state.newPasswdHint2}
              type="password"
            />
          </label>
        </>
            ) : (
              <Card 
                text="密码已修改成功。"
                className={style.card}
              />
            )
        }
        <label className={style.label}>
          <Button
            title="确定"
            type="green"
            className={style.button}
            onClick={onSubmit}
            loading={state.loading}
          />
        </label>
      </div>
    </Model>
  )
}

export default ModifyPasswd
